import {Injectable} from '@angular/core';

import {BehaviorSubject, Observable} from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';

import {TreeUpdateObject, UpdateTreeChildren} from '../models/rme/tree-update-object';

@Injectable({
  providedIn: 'root'
})
export class UpdateTreeService {
  private updateNodeInTreeSubject = new BehaviorSubject<TreeUpdateObject>(undefined);
  private updateNodeInTree$ = this.updateNodeInTreeSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  private updateChildrenNodesInTreeSubject = new BehaviorSubject<UpdateTreeChildren>(undefined);
  private updateChildrenNodesInTree$ = this.updateChildrenNodesInTreeSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  get updateNodeInTree() {
    return this.updateNodeInTreeSubject.value;
  }

  get updateChildrenNodesInTree() {
    return this.updateChildrenNodesInTreeSubject.value;
  }

  select<T>(name: string): Observable<any> {
    return this[`${name}$`];
  }

  set(name: string, stateValue: any) {
    this[`${name}Subject`].next(stateValue);
  }
}
